module.exports = __webpack_public_path__ + "assets/coco_light.4a807a37.svg";